<login-alt-layout pageTitle="Accessibility">
  <h3>Section 504 – Auxiliary aids and services</h3>

  <p>
    The Centers for Medicare &amp; Medicaid Services (CMS) is responsible for
    complying with Section 504 of the Rehabilitation Act of 1973 (Section 504),
    29 U.S.C. § 794, and for ensuring that all Medicare contractors, Medicare
    Advantage Plans, Medicare Prescription Drug Plans, and Quality Improvement
    Organizations comply with these requirements. Section 504 prohibits
    discrimination on the basis of disability in federally assisted and
    federally conducted programs and activities.
  </p>

  <p>
    For information about the availability of auxiliary aids and services,
    visit:
    <a
      href="http://www.medicare.gov/about-us/nondiscrimination/nondiscrimination-notice.html"
      >http://www.medicare.gov/about-us/nondiscrimination/nondiscrimination-notice.html</a
    >.
  </p>

  <h3>Section 508 - EIT Accessibility</h3>

  <p>
    The Centers for Medicare &amp; Medicaid Services (CMS) is committed to
    making its Web sites and all of its electronic and information technology
    (EIT) accessible to the widest possible audience, including individuals with
    disabilities. In keeping with its mission, CMS complies by implementing the
    regulations of Section 508 of the Rehabilitation Act and the Department of
    Health &amp; Human Services (HHS) Section 508 Implementation Policy.
  </p>

  <h4>Synopsis of Section 508 Accessibility Requirements</h4>

  <p>
    Section 508 of the Rehabilitation Act of 1973, as amended by the Workforce
    Investment Act of 1998, requires that when Federal agencies procure,
    develop, maintain, or use EIT, they ensure that Federal employees and
    members of the public with disabilities have access to and use of
    information and data that is comparable to the access to and use of
    information and data that is available to individuals without disabilities.
  </p>

  <p>
    The first regulation implementing Section 508 was issued by the
    Architectural and Transportation Barriers Compliance Board (the “Access
    Board”), an independent Federal agency, whose primary mission is to promote
    accessibility for individuals with disabilities. This regulation is referred
    to as the Access Board’s “EIT Accessibility Standards,” which became
    enforceable on June 21, 2001. The Access Board’s standards set forth a
    definition of EIT and the technical and functional provisions and
    performance criteria necessary for compliance with Section 508.
  </p>

  <p>
    In January 2005, the Secretary of HHS signed the "HHS Policy for Section 508
    Electronic and Information Technology (EIT)." This policy establishes
    guidance for implementing Section 508 throughout the Department.
  </p>

  <p>
    In June 2006, the CMS Administrator issued the "CMS Policy for Section 508
    Compliance," which establishes the policy by which CMS will ensure
    compliance with Section 508. In August 2006, CMS also issued the Agency's
    procedure for submitting and handling a complaint that alleges that CMS does
    not comply with Section 508 in providing accessible EIT.
  </p>

  <p>
    Although Federal agencies have an explicit statutory obligation to make all
    EIT that they develop, procure, maintain, or use compliant with Section 508,
    individuals may only file complaints or lawsuits to enforce Section 508’s
    requirements with respect to EIT systems procured or deployed on or after
    June 21, 2001. The Section 508 requirements do not apply retroactively to
    pre-existing EIT. However, as agencies upgrade and change their EIT, they
    must comply with the standards. Specifically, the Electronic and Information
    Technology Accessibility Standards: Economic Assessment states that:
  </p>

  <p>
    "The standards are to be applied prospectively and do not require Federal
    agencies to retrofit existing electronic and information technology. As
    agencies upgrade and change their electronic and information technology,
    they must comply with the standards."
  </p>

  <p>
    It should be noted, however, that Federal agencies have additional
    responsibilities under Section 501 and Section 504 of the Rehabilitation
    Act. These Sections require that agencies provide reasonable accommodation
    to employees with disabilities and provide program access to members of the
    public with disabilities and take other actions necessary to prevent
    discrimination on the basis of disability in their programs.
  </p>

  <p>
    <strong>Note:</strong> HARP does not support Internet Explorer (IE). Please
    use a different browser.
  </p>
</login-alt-layout>
